import React from 'react';
import './CultureLab.css';

function CultureLab() {
  return (
    <div className="culture-lab-container">
      <div className="culture-lab-image">
        <img src="/culture-lab.jpg" alt="旅游信息融合处理与数据权属保护文化和旅游部重点实验室" />
      </div>
      <div className="culture-lab-content">
        <h1>文旅重点实验室</h1>

        <h2>实验室背景</h2>
        <p>
          旅游信息融合处理与数据权属保护文化和旅游部重点实验室，依托兰州大学信息科学与工程学院，以国家文化和旅游信息处理的重大战略需求为目标，立足于智慧旅游信息科学的国际前沿和我国现代文化和旅游行业建设的重大问题，探索研究文化和旅游行业中的旅游信息融合处理研究、旅游数据权属保护研究等科学问题，形成一系列的重大研究成果，推动兰州大学信息学科的发展。
        </p>

        <h2>研究内容</h2>
        <p>
          实验室将围绕目前旅游信息共享开放程度不够、关键技术支撑能力不强、信息资源应用领域不广、数据安全管理体系不完善、专业人才队伍规模和素质不够等问题，从信息处理和数据安全两方面开展以下两个关键技术研究：旅游信息融合处理和旅游数据权属保护。这两个研究方向之间相互联系，各有侧重，是一个有机的整体。通过这两个研究方向，建立旅游信息的使用机制，探索旅游信息的应用价值，创新旅游行业提升竞争力的手段，提升游客体验的同时保障游客个人隐私。
        </p>

        <h2>科研力量</h2>
        <p>
          目前固定研究人员25人，包括管理人员2人，研究人员17人，技术人员6人。其中教授8人，副教授10人，高级实验师1人，讲师4人，助理研究员2人；包括博士学历22人，硕士学历3人；研究人员年龄结构合理，其中30-40岁9人，41-50岁11人，51岁以上5人，是一支由国内有一定影响力的研究学者为核心，以中青年研究人员为骨干的科研队伍。
        </p>
        <p>
          此外，实验室有流动人员32人，均为实验室在读或已毕业博士或硕士研究生。
        </p>

        <h2>学术委员会</h2>
        <p>
          主任：郑纬民，中国工程院院士，清华大学计算机系教授。
        </p>
        <p>
          委员：吴飞，国家杰出青年科学基金获得者，浙江大学教授。武永卫，中组部“万人计划”科技创新领军人才，清华大学教授。殷建平，中组部“万人计划”国家级教学名师，国防科技大学教授。吴尽昭，中国科学院“百人计划（国外引入杰出人才）”入选者，广西大学教授。李廉，中国计算机学会杰出贡献奖，合肥工业大学教授。秦炳峰，甘肃省一等功公务员，甘肃省文化和旅游厅科技信息处处长。刘康，江西省政府信息化智库专家，江西省文化和旅游厅科技教育处处长。张毅，原中国人民解放军某部研究员，上海市文化和旅游旅局信息科技处处长处长共9人。学术委员会成员均为我国数据领域的知名专家和旅游领域的行业专家。
        </p>

        <h2>基础条件</h2>
        <p>
          目前实验室拥有总面积达710m²的实验室、会议室、大数据指挥中心，并拥有多台价值超过30万人民币的先进仪器设备，包括网络安全专用服务器、模拟计算平台、数据采集系统CTI3000、华为RH2288V3专用服务器、华为Logcenter专用服务器、IBM数据专用服务器等。
        </p>

        <h2>成果及贡献</h2>
        <h3>在推动行业发展方面的贡献</h3>
        <p>
          长期参与甘肃省智慧文旅重大发展规划编制和省列重大项目“一部手机游甘肃”的项目设计与实施，为全省文化旅游智慧化、信息化建设提供了智力支撑。积极参与全国智慧旅游的建设与发展，多次参加国家文化和旅游部和学术机构召开的相关研讨会议，并介绍甘肃省智慧旅游建设的经验。积极参与其它省份的智慧旅游项目建设。
        </p>
        <p>
          全程参与甘肃智慧文旅规划编制，主导《关于加快建设旅游强省的意见》（甘发〔2018〕7号）智慧旅游板块的起草，该文件于2018年2月由省委省政府印发；主导《关于加快全省智慧旅游建设的意见》（甘政办发〔2018〕22号）的起草，该文件于2018年2月由省政府办公厅印发；全程主导《甘肃省智慧旅游建设三年行动计划（2018-2020年）》（甘旅办发〔2018〕17号）起草，2018年3月由原省旅发委印发实施。
        </p>
        <p>
          主导并实施了安徽省文旅厅智慧旅游项目“游安徽”和广州市文旅局智慧旅游项目“一部手机游广州”，以及甘肃省7个地市的智慧旅游项目。
        </p>

        <h3>在推动行业技术进步方面的贡献</h3>
        <p>
          实验室全面负责“甘肃文旅大数据中心”建设运营的技术指导，提供了关键性贡献。牵头“甘肃省旅游文化大数据交换共享平台”和“一部手机游甘肃综合服务平台”的设计和建设，这两项均被文化与旅游部选入了“2020年度文化和旅游信息化发展典型案例”。 2019年10月、2020年3月和2020年10月，省委书记、省人大常委会主任领导，国家文旅部办公厅分别调研甘肃文旅大数据中心，实验室做了工作汇报与现场讲解。甘肃文旅大数据建设于2019年5月荣获腾讯全球数字生态大会“数字文旅先锋奖”。
        </p>

        <h3>解决文化和旅游系统改革发展重大科技需求与关键问题方面的贡献</h3>
        <p>
          甘肃省委省政府抓建的重大信息化建设工程“一部手机游甘肃”综合服务平台中，2019年3月纳入省列重大项目。实验室从“一机游”建设工程启动之初，就全程主导了方案策划，项目实施，环境完善，以及基础设施建设，构建满足游客个性化需求的景区、旅行社、导游、酒店、民宿等服务板块。通过运用数据融合算法、数据挖掘算法、云计算、人工智能算法等对旅游信息进行分析建模研究，得到旅游信息中隐藏的信息，解决目前旅游转型过程中旅游信息共享开放程度不够、关键技术支撑能力不强、信息资源应用领域不广、数据安全管理体系不完善、专业人才队伍规模不够大和素质不够强等关键问题。2018年8月，由兰州大学和原省旅发委共同主办的首届甘肃智慧旅游与区块链建设高峰论坛在兰州举办，与会专家学者一致认为“一机游”平台全国领先。2019年5月，“一部手机游甘肃”荣获第四届中国文旅产业巅峰大会文化和旅游产业年度突出贡献奖。
        </p>

        <h2>人才培养</h2>
        <p>
          实验室十分重视对人才的吸引和培养，先后引进北京大学、肯特州立大学、巴黎第十一大学、悉尼科技大学等科研院所各类人才。实验室作为国内外科研合作与学术交流的平台，近5年来先后主办了4次国际性学术会议，7次全国性学术会议，有多人作为访问学者赴国外研究机构，并邀请外籍专家进行交流，形成了充分利用国际国内两种科技资源，克服区位不足，建设高水平科技队伍的模式。
        </p>
      </div>
    </div>
  );
}

export default CultureLab;